<div class="modalShareProfile">
  <div class="backArrowSection">
    <ion-icon (click)="goBack()" name="close-outline"></ion-icon>
  </div>

  <div class="modalShareProfileContent">
    <div class="imgShare">
      <img class="logoAvocadoShare" src="assets/imgs/avocados.svg" alt="Share">
    </div>

    <span class="title">{{'shareWithYourFriends' | translate}}</span>

    <div class="description">
      {{'friendsDontLetFriendsDateCarnists' | translate}}
    </div>
    <br>

    <ion-button expand="block" class="button-edit-profile-share" shape="round" class="button-edit-profile-share" (click)="profileShare()">
      {{'share' | translate}}
    </ion-button>
  </div>
</div>